export default {
    intro: {
        title: '{name} 선생님,',
        description: '매일국어T에 오신 것을\n환영합니다!',
    },
    steps: {
        step1: {
            title: '어느 학년을 가르치시나요?',
            options: '{year}학년',
            start_up: {
                title: '시작 방식을 선택해주세요.',
                options: {
                    experience: {
                        title: '먼저 체험해보기',
                        description: '선생님과 학생을\n모두 체험해볼 수 있어요',
                    },
                    start_up: {
                        title: '우리 학급으로 시작하기',
                        description: '우리 학급 정보를 입력하고\n수업을 시작할 수 있어요',
                    },
                },
            },
        },
        experience: {
            title: '체험을 진행하고 있어요',
            description:
                '선생님 화면에서 활동을 제어하고, 학생 화면에서 문제를 풀어보세요\n나중에 언제든지 다시 해볼 수 있어요',
            popup_warning:
                '팝업 차단으로 화면이 보이지 않을 수 있어요.<br />팝업 차단을 해제하거나 학생 화면, 선생님 화면 버튼을 눌러 ON으로 설정해 주세요.',
            controller: {
                studentMonitor: '학생 화면',
                teacherMonitor: '선생님 화면',
                exit: '체험종료',
            },
        },
        register: {
            title: '학급 이름을 지어주세요',
            placeholder: '2~8자 이내 (ex. 3반, 에너지뿜뿜)',
            description: '내 정보 > 학급 정보에서 언제든 수정할 수 있어요',
            buttons: {
                later: '나중에 정할게요',
                create: '학급 만들기',
                register: '시작하기',
                prev: '이전',
            },
        },
    },
    outro: {
        title: '새로운 학급이 생겼어요!',
        description: '<span>{grade}학년 {name}</span>에서\n학생들과 다양한 활동을 진행해보세요.',
    },
};
